import React from 'react'

type Props = { username: string; user: string; date: string; time: string; amount?: number }

export const AcknowledgedByChannelsPT = ({ username, date, time, amount }: Props): JSX.Element => (
    <>
        Reconhecido em {date} {time}
        <br /> Por <strong>{username}</strong> {!!amount && `e +${amount} outros`}
    </>
)

export const AcknowledgedByChannels = ({ username, date, time, amount }: Props): JSX.Element => (
    <>
        Acknowledged at {date} {time}
        <br /> By <strong>{username}</strong> {!!amount && `and +${amount} others`}
    </>
)
